import axios from "../services/axios/backendAxios";
import { getAuth, getIdToken } from "firebase/auth";
import { useCallback } from "react";
import firebaseAuth from "../services/firebase/firebaseAuth";
import jobHistoryReportFields from "../utils/jobHistoryReportFields";

const createInput = (name, value, type) => {
  const input = document.createElement("input");
  input.type = type || "text";
  input.name = name;
  input.value = value;
  return input;
};

const useJobHistoryReport = ({
  companies,
  dateRange = {},
  services = [],
  jobs = [],
  cities = [],
  flaggedForReview = null,
  season = null,
  searchPhrase = null,
  operators = [],
  routes = [],
  servicedBy = [],
}) => {
  const createJobHistoryReport = useCallback(() => {
    firebaseAuth.getUser(async () => {
      // Create a hidden form element
      const form = document.createElement("form");
      form.style.display = "none"; // Hide the form

      // Collects a fresh token
      const token = await getIdToken(getAuth().currentUser);

      // Set form attributes
      form.method = "POST";
      form.action = axios.defaults.baseURL + "/report/job-history";
      form.target = "_blank"; // Open response in a new tab

      // Append form inputs to the form
      const fields = jobHistoryReportFields({
        companies,
        dateRange,
        services,
        jobs,
        cities,
        operators,
        routes,
        servicedBy,
        season,
        flaggedForReview,
        searchPhrase,
      });
      for (const [name, value] of fields) {
        form.appendChild(createInput(name, value));
      }

      form.appendChild(createInput("authToken", token, "hidden"));

      // Append the form to the document body
      document.body.appendChild(form);

      // Submit the form
      form.submit();
    });
  }, [
    companies,
    dateRange,
    services,
    jobs,
    cities,
    operators,
    flaggedForReview,
    routes,
    servicedBy,
    searchPhrase,
    season,
  ]);

  return { createJobHistoryReport };
};

export default useJobHistoryReport;
